import { createContext, useContext, useState, useEffect } from "react";
import Loading from "../loading";
import { getUserProfileImageURL } from "../utils";
import { getCurrentUser, logout, VerifyCode } from "../../services/auth";

const AuthContext = createContext(undefined);

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  console.log("AuthProvider - currentUser:", currentUser);
  const [loading, setLoading] = useState(true);

  const handelLogin = async (userID = "", verificationCode = "") => {
    const res = await VerifyCode(userID, verificationCode);
    console.log("res from handelLogin", res);
    if (res.success) {
      const connectedUser = {
        ...res.data,
        image: getUserProfileImageURL(res.data?.userId),
      };

      setCurrentUser(connectedUser);
    }
    return res;
  };

  const handelLogout = async () => {
    const res = await logout(currentUser?.userId);
    if (res) {
      setCurrentUser(null);
    } else {
      console.error("error API logout");
    }
  };

  const updateCurrentUser = async (userInfo) => {
    const userData = { ...currentUser, ...userInfo };
    setCurrentUser(userData);
  };

  useEffect(() => {
    getCurrentUser()
      .then((user) => {
        const userWithImage = {
          ...user,
          image: getUserProfileImageURL(user.userId),
        };

        setCurrentUser(userWithImage);
      })
      .catch((err) => {
        setCurrentUser(null);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <Loading />;
  }

  return (
    <AuthContext.Provider
      value={{ currentUser, handelLogin, handelLogout, updateCurrentUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);

  if (context === undefined) {
    throw new Error("useAuth must be used inside of a AuthProvider");
  }

  return context;
}
